<template>
<transition name="appear-transition">
  <div v-show="isReady" class="home">
    <div class="pages-wrapper">
      <transition name="single-page-transition">
        <div v-show="activeSlide == 0" class="single-page">
          <div class="bg-centered">
            <img src="@/assets/sad.png" alt="">
          </div>
          <div class="content">
            <h1 v-html="content['un_leave']"></h1>
          </div>
          <div class="fixed-content-wrapper">
            <div class="button-wrapper">
                <button v-html="content['un_unsubscribe']" class="unsubscribe-button" @click="unsubscribe"></button>
                <button v-html="content['un_keep']" class="main-button" @click="nextSlide"></button>
            </div>
            <div class="footer-links"></div>
          </div>
        </div>
      </transition>
      <transition name="single-page-transition">
        <div v-show="activeSlide == 1" class="single-page">
          <div class="bg">
            <img src="@/assets/downloadBg.png" alt="">
          </div>
          <div class="fixed-content-wrapper">
            <div class="carousel-slide-holder">
                <div class="carousel-slide">
                    <div class="carousel-slide-content-no-bg">
                        <h3 v-if="premiumLost" v-html="content['un_lost']"></h3>
                        <h3 v-else v-html="content['un_keept']"></h3>
                        <p v-if="premiumLost" v-html="content['un_succ']"></p>
                        <p v-else v-html="content['un_remained']"></p>
                    </div>
                </div>
            </div>
            <div class="button-wrapper">
              <button v-html="content['un_start']" class="main-button" @click="restart"></button>
            </div>
            <div class="footer-links"></div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</transition>
</template>

<script>
import dataManager from '@/managers/dataManager.js'
import contentManager from '@/managers/contentManager.js'
import parametersManager from '@/managers/parametersManager.js'

export default {
  name: "home",
  data () {
    return {
      content:contentManager.content,
      activeSlide:0,
      isReady:false,
      premiumLost:false
    }
  },
  methods:{
    unsubscribe(){
      let that = this
        dataManager.unsubscribe(parametersManager.URLParams.subscription_id).then((res)=>{
        that.premiumLost = true
        that.nextSlide()
      }).catch((err)=>{
        that.premiumLost = false
        that.nextSlide()
      })
    },
    restart(){
      this.isReady = false
      setTimeout(() => {
        window.location.href = window.location.origin;
      }, 500);
    },
    nextSlide(){
      this.activeSlide = 1;
    },
  },
  mounted () {
    this.isReady = true
  }
};
</script>

<style scoped>
.home{
  min-height: 100%;
}
.single-page{
  position: fixed;
  top:0;
  left:0;
  width:100%;
  height:100%;
}
.bg{
  position: fixed;
  top:0;
  left:0;
  z-index: 1;
  width:100%;
  height:100%;
}
.bg-centered{
  position: fixed;
  top:0;
  left:0;
  z-index: 1;
  width:100%;
  height:100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding:0px 30px;
  background:black;
}
.bg-centered img{
    width:100%;
    margin-bottom: 25px;
}
.bg video{
  width:100%;
  height:100%;
  object-fit: cover;
  object-position: center;
}
.content{
  position: fixed;
  top:0;
  left:0;
  z-index: 3;
  width:100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.content h1{
  text-align: center;
  font-size: 25px;
  line-height: 32px;
  color:white;
  margin:0;
  margin-top:25px;
}
.fixed-content-wrapper{
  position: fixed;
  bottom:0;
  left:0;
  width:100%;
  z-index: 4;
  padding:0px 0px;
}
.main-button{
  outline: none;
  border:none;
  background:none;
  width:100%;
  height:50px;
  color:white;
  font-weight: bold;
  font-size: 18px;
  line-height: 18px;
  background: rgb(255,66,74);
  background: -moz-linear-gradient(left,  rgba(255,66,74,1) 0%, rgba(255,41,133,1) 100%);
  background: -webkit-linear-gradient(left,  rgba(255,66,74,1) 0%,rgba(255,41,133,1) 100%);
  background: linear-gradient(to right,  rgba(255,66,74,1) 0%,rgba(255,41,133,1) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ff424a', endColorstr='#ff2985',GradientType=1 );
  border-radius: 100px;
  margin:0;
}
.unsubscribe-button{
  outline: none;
  border:none;
  background:none;
  width:100%;
  height:50px;
  color:white;
  font-weight: 500;
  font-size: 18px;
  line-height: 18px;
}
.single-page-transition-enter{
  transform: translateX(100%);
}
.single-page-transition-enter-to, .single-page-transition-leave{
  transform: translateX(0%);
}
.single-page-transition-leave-to{
  transform: translateX(-100%);
}
.single-page-transition-enter-active{
  transition: all .15s ease-in;
}
.single-page-transition-leave-active{
  transition: all .15s ease-in;
}
.footer-links{
  width:100%;
  height:35px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.footer-links button{
  outline: none;
  border:none;
  background:none;
  color:white;
  font-size: 12px;
  line-height: 12px;
  padding: 5px 0px;
  margin:0px
}
.footer-links span{
  color:rgb(140,140,140);
  font-size: 12px;
  line-height: 12px;
  padding: 5px 0px;
  margin:0px 5px;
}
.carousel-wrapper{
  width:100%;
  position: relative;
}
.carousel-slide{
  width:100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom:0;
  padding:0px 30px;
}
.carousel-slide-holder h2, .carousel-slide h2{
  color:white;
  text-align: center;
  font-size: 25px;
  line-height: 32px;
  margin: 0px;
}
.carousel-slide-holder h3, .carousel-slide h3{
  color:white;
  text-align: center;
  font-size: 20px;
  line-height: 20px;
  margin: 0px;
}
.carousel-slide-holder p, .carousel-slide p{
  color:white;
  text-align: center;
  font-size: 16px;
  line-height: 22px;
  font-weight: 600;
  margin: 0px;
  margin-top:5px;
  margin-bottom: 10px;
}
.carousel-slide-content{
  position: absolute;
  width:100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.carousel-slide-content-no-bg{
  width:100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.carousel-bg{

}
.carousel-slide-holder{
  width:100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 32px;
  position: relative;
}
.carousel-slide-holder h2{
  color:white;
  text-align: center;
  font-size: 25px;
  line-height: 32px;
  position: absolute;
  width:100%;
}
.carousel-slide-transition-enter{
  transform: translateX(100%);
}
.carousel-slide-transition-enter-to, .carousel-slide-transition-leave{
  transform: translateX(0%);
}
.carousel-slide-transition-leave-to{
  transform: translateX(-100%);
}
.carousel-slide-transition-enter-active{
  transition: all .3s ease-in;
}
.carousel-slide-transition-leave-active{
  transition: all .3s ease-in;
}

.add-apple-pay-transition-enter{
  opacity: 0;
}
.add-apple-pay-transition-enter-to, .add-apple-pay-transition-leave{
  opacity: 1;
}
.add-apple-pay-transition-leave-to{
  opacity: 0;
}
.add-apple-pay-transition-enter-active{
  transition: all .15s linear;
}
.add-apple-pay-transition-leave-active{
  transition: all .15s linear;
}


.appear-transition-enter{
  opacity: 0;
}
.appear-transition-enter-to, .appear-transition-leave{
  opacity: 1;
}
.appear-transition-leave-to{
  opacity: 0;
}
.appear-transition-enter-active{
  transition: all .6s linear 1s;
}
.appear-transition-leave-active{
  transition: all .6s linear;
}


.button-wrapper{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width:100%;
  padding: 0px 30px;
}
.download{
  width:100%;
  text-align: center;
  color:white;
  margin:0;
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
  margin-bottom: 25px;
}
.raeting{
  display: flex;
  align-items: center;
  justify-content: center;
  width:100%;
  margin-top:15px;
}
.raeting-person-wrapper{
  width: 100%;
  padding:0px;
}
.raeting-person{
  display: flex;
  align-items: center;
  justify-content: space-between;
  width:100%;
  padding-top:10px;
  border-top:1px solid rgba(255, 255, 255, .2);
}
.raeting span, .raeting-person-info span{
  color:white;
  font-weight: 600;
  font-size: 18px;
  line-height: 18px;
}
.raeting img{
  width:105px;
  margin-left:5px;
}
.five-stars{
  width:105px;
}
.raeting-person-info{
  display: flex;
  align-items: center;
  justify-content: center;
}
.raeting-person-info img{
  border-radius: 100px;
  margin-right: 15px;
  width:40px;
}
.overlay{
  position: fixed;
  bottom: 0;
  left:0;
  z-index: 2;
  width:100%;
  background: -moz-linear-gradient(top,  rgba(0,0,0,0) 0%, rgba(0,0,0,1) 100%);
  background: -webkit-linear-gradient(top,  rgba(0,0,0,0) 0%,rgba(0,0,0,1) 100%);
  background: linear-gradient(to bottom,  rgba(0,0,0,0) 0%,rgba(0,0,0,1) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00000000', endColorstr='#000000',GradientType=0 );
}
.overlay img{
  width:100%;
}
.apps-wrapper{
  width:100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.apps-wrapper img{
  width:40px;
  margin:12px;
  opacity: .4;
  transition:all .3s linear;
}
.apps-wrapper img.active{
  opacity: 1;
}
.price-description{
  font-weight: 600;
  color:white;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
}
.price-info{
  display:flex;
  align-items: center;
  justify-content: center;
}
.price-info span{
  font-weight: 800;
  color:white;
  font-size: 25px;
  line-height: 25px;
}
.price-info .price{
  padding:8px;
  background:rgb(79, 174, 178);
  border-radius: 8px;
}
.r-price-info{
  width:100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin:0px 0px 10px 0px;
}
.r-price{
  opacity: .4;
  color:white;
  text-align: center;
  font-size: 14px;
  line-height: 14px;
}
.loader{
  width:30px;
  height:30px;
  filter:brightness(2);
  animation: spin 1s linear infinite;
}
.loading-wrapper{
  height:50px;
  width:100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
@keyframes spin {
  0%{
    transform: rotate(0deg);
  }
  100%{
    transform: rotate(-359deg);
  }
}
.bg img{
  width:100%;
  height:100%;
  object-fit: cover;
  object-position: center;
}
.download-button{
  outline: none;
  border:none;
  background:none;
  width:225px;
  height:75px;
  border-radius: 15px;
  overflow: hidden;
}
.download-button img{
  width:100%;
  border-radius: 15px;
  overflow: hidden;
}
.spinner-wrapper{
  width:100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.spinner-wrapper img{
  width:20px;
  height: 20px;
  transition: all .3s linear;
}
.payment-button-wrapper{
  width:100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.add-apple-pay-wrapper{
  position: fixed;
  top:0;
  left:0;
  width:100%;
  height:100%;
  z-index: 9999999;
  background:rgba(0, 0, 0, .8);
  display: flex;
  align-items: center;
  justify-content: center;
  padding:0px 30px;
}
.add-apple-pay-inner{
  display: flex;
  flex-direction: column;
  align-items:center;
  justify-content: center;
  width:100%;
  background:white;
  padding:30px;
  border-radius: 15px;
}
.add-apple-pay-inner h3{
  text-align: center;
  font-size: 20px;
  line-height: 26px;
  margin-top:18px;
  margin-bottom: 30px;
}
.add-apple-pay-inner img{
  width:155px;
}
@media screen and (max-height:568px) {
  .bg-centered img{
    width:70%;
  }
  .price-description{
    font-size: 10px;
    line-height: 14px;
  }
  .price-info span{
    font-size: 18px;
    line-height: 22px;
  }
  .carousel-slide-holder h2, .carousel-slide h2{
    font-size: 20px;
    line-height: 28px;
  }
  .carousel-slide-holder h3, .carousel-slide h3{
    font-size: 18px;
    line-height: 18px;
  }
  .carousel-slide-holder p, .carousel-slide p{
    font-size: 12px;
    line-height: 18px;
  }
  .five-stars{
    width:80px;
  }
  .raeting img{
    width:80px;
  }
  .raeting-person-info span, .raeting span{
    font-size: 14px;
    line-height: 14px;
  }
  .content h1{
    font-size: 16px;
    line-height: 20px;
  }
  .carousel-slide-holder{
    margin-bottom: 20px;
  }
  .r-price{
    font-size: 12px;
    line-height: 12px;
  }
  .footer-links button, .footer-links span{
    font-size: 10px;
  }
}

@media screen and (height:667px) {
  .five-stars{
    width:80px;
  }
  .raeting img{
    width:80px;
  }
}

@media screen and (height:736px) {
  .five-stars{
    width:90px;
  }
  .raeting img{
    width:90px;
  }
}

@media screen and (height:812px) {

}

@media screen and (height:844px) {

}

@media screen and (height:896px) {

}
</style>
<style>
.login-button svg {  
  height: 50px !important;  
  width: 100%;  
} 
.login-button, .login-button *{
  outline: none !important;
}
</style>
